module.exports = __webpack_public_path__ + "img/weather-snow.9d7729f8.png";